import { getEventDesktop } from "app/api/eventsApi";
import { EventType } from "app/types/eventType";
import { NavigationMetaType } from "app/types/navigationType";
import { EventStatus } from "app/utils/const";
import { History } from "history";
import {
  getCompetitionIdFromName,
  getCountryIdFromNameAndSportId,
  getSportIdFromName,
} from "./nameHelper";
import {
  findCompetitionDetails,
  findCountryDetails,
} from "./routeHandlerHelper";

type RouteHandlerProps = {
  navigationTree: NavigationMetaType[];
  updateFiltering: (
    navNodeIds: number[],
    selectedSport: NavigationMetaType | null,
    selectedCountry: NavigationMetaType | null,
    selectedCompetition: NavigationMetaType | null
  ) => void;
  setNavigationNodeIds: (nodeIds: number[]) => void;
  updateCompetitionListType: (type: string) => void;
  updateCompetitionListTime: (time: string) => void;
  setCompetitions: (options?: { fullList?: boolean }) => void;
  setSingleCompetition: (competitionId: number) => void;
  disableFilter: (disable: boolean) => void;
  updateUnsummarizedMarketsModalEvent: (event: EventType) => void;
  resetCompetitions: () => void;
  history: History;
};

export const handleCompetitionRoute = (
  id: string,
  props: RouteHandlerProps
) => {
  const numericId = Number(id);
  const competitionId = !isNaN(numericId)
    ? numericId
    : getCompetitionIdFromName(id);

  if (!competitionId) {
    console.log("competitionId not found", id);
    props?.history?.push?.("/events/");
    return;
  }

  const sports = props.navigationTree[0].nodes;
  const result = findCompetitionDetails(sports, competitionId);

  if (result) {
    const { sport, country, competition } = result;
    props.updateFiltering(
      [sport.id, country.id, competitionId],
      sport,
      country,
      competition
    );
  }
  props.disableFilter(true);
  props.updateCompetitionListType("ALL");
  competitionId && props.setSingleCompetition(competitionId);
};

export const handleSportRoute = (
  id: string,
  filter: string | null,
  period: string | null,
  country: string | null,
  props: RouteHandlerProps
) => {
  const numericId = Number(id);
  const sportId = !isNaN(numericId) ? numericId : getSportIdFromName(id);

  if (!sportId) {
    console.log("sportId not found", id);
    props?.history?.push?.("/events/");
    props.resetCompetitions();
    props.setCompetitions();
    return;
  }

  const sportObject = props.navigationTree[0].nodes.find(
    sport => sport.id === sportId
  );

  if (country && sportObject) {
    const countryId = getCountryIdFromNameAndSportId(country, sportId);

    if (countryId && typeof countryId === "number") {
      const result = findCountryDetails(sportObject, countryId);
      if (result && typeof countryId === "number") {
        const navNodeIds = [sportId, countryId];
        props.updateFiltering(navNodeIds, result.sport, result.country, null);
        props.setNavigationNodeIds(navNodeIds);
        filter && props.updateCompetitionListType(filter.toUpperCase());
        period && props.updateCompetitionListTime(period.toUpperCase());
        props.resetCompetitions();
        props.setCompetitions();
        return;
      }
    }
  }

  props.updateFiltering([sportId], sportObject || null, null, null);
  props.setNavigationNodeIds([sportId]);
  filter && props.updateCompetitionListType(filter?.toUpperCase());
  period && period && props.updateCompetitionListTime(period?.toUpperCase());
  props.setCompetitions();
};

export const handleEventsRoute = (
  props: RouteHandlerProps,
  filter?: string,
  period?: string
) => {
  filter && props.updateCompetitionListType(filter.toUpperCase());
  period && props.updateCompetitionListTime(period.toUpperCase());
  props.updateFiltering([], null, null, null);
  props.setNavigationNodeIds([]);
  props.resetCompetitions();
  props.setCompetitions();
  props.disableFilter(false);
};

export const handleFavouritesRoute = (props: RouteHandlerProps) => {
  props.resetCompetitions();
  props.setCompetitions();
};

export const handleEventRoute = async (
  id: string | undefined,
  props: RouteHandlerProps
) => {
  if (!id) {
    console.log("eventId is undefined");
    props?.history?.push?.("/events/");
    return;
  }

  const eventId = id?.split?.("-")?.[0];
  if (!eventId || isNaN(Number(eventId))) {
    console.log("eventId not found", id);
    props?.history?.push?.("/events/");
    return;
  }

  const resp = await getEventDesktop(Number(eventId), false, false);
  if (resp.status === EventStatus.CLOSED) {
    console.log("event is closed, redirecting to events");
    props?.history?.push?.("/events/");
    return;
  }

  const event = resp;
  event.competition.sportType = event.sportType;

  const nodeIds = event.competition.navigationNodeIds;
  const [sportId, countryId, competitionId] = nodeIds;

  const selectedSport = props.navigationTree[0].nodes.find(
    sport => sport.id === sportId
  );
  const selectedCountry = selectedSport?.nodes.find(
    country => country.id === countryId
  );
  const selectedCompetition = selectedCountry?.nodes.find(
    competition => competition.id === competitionId
  );

  props.updateFiltering(
    nodeIds,
    selectedSport || null,
    selectedCountry || null,
    selectedCompetition || null
  );
  props.disableFilter(true);
  props.updateUnsummarizedMarketsModalEvent(event);
};
